module.exports = "/_next/static/images/circleweb-bd1dc70d74894bac567b8da65b26fd28.png";